import { randomUuid } from "./util";
import lodash from "lodash";

export const clearId = record => {
    if (record && Array.isArray(record)) {
        record.forEach(d => clearId(d));
    } else if (record && typeof record === "object") {
        for (const key in record) {
            const value = record[key];
            if (key === "id") {
                record.id = null;
                record._id = randomUuid();
                record.isSave = true;
                record.version = null;
                record.createBy = null;
                record.createDate = null;
                record.updateBy = null;
                record.updateDate = null;
            } else if (Array.isArray(value)) {
                value.map(it => {
                    clearId(it);
                });
            } else if (value && typeof value === "object" && value.totalSize) {
                clearId(value);
            }
        }
    }
    return record;
};

export const popAll = list => {
    while (list?.length > 0) {
        list.pop();
    }
};

export const getDeep = ({ items, childrenKey = "children", findFunc }) => {
    return lodash.cloneDeep(items).filter(item => {
        if (lodash.get(item, childrenKey)?.length > 0) {
            lodash.set(item, childrenKey, getDeep({ items: item.children, childrenKey, findFunc }));
            if (lodash.get(item, childrenKey)?.length > 0) {
                return true;
            } else {
                lodash.set(item, childrenKey, undefined);
                return findFunc({ item });
            }
        } else {
            lodash.set(item, childrenKey, undefined);
            return findFunc({ item });
        }
    });
};
